import { Wrapper } from '@screentone/core';

import { CommonEntityProps } from 'components/datamodel/commonEntityProps';
// eslint-disable-next-line import/no-cycle -- TODO: pre-existing cycle via DataModelContext, fix when context is restructured
import { useDataModelContext } from 'contexts/datamodel/useDataModel';
import { SectionContainer } from 'data/generated/graphql';

interface SectionProps extends CommonEntityProps {
  data: SectionContainer;
}

export const Section = ({ data: section, parentHierarchyId, index, isHistory, isReadOnly }: SectionProps) => {
  const { generateHierarchyId, renderEntity } = useDataModelContext();

  const hierarchyId = generateHierarchyId(section, parentHierarchyId, index);

  return (
    <Wrapper data-model-hierarchy-id={hierarchyId} margin={{ bottom: 'md' }}>
      {section.collection.map((page, i) => (
        <div key={i}>{renderEntity(page, { hierarchyId, index: i, isHistory, isReadOnly })}</div>
      ))}
    </Wrapper>
  );
};
